// removed by extract-text-webpack-plugin
module.exports = {"modal":"image-modal-container__modal__Wqy23","image":"image-modal-container__image__1q3TO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/image-modal-container.scss
// module id = 1298
// module chunks = 1